var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
var TotalBar = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 8px;\n  border: 0.5px solid rgba(24, 32, 38, 0.16);\n  border-radius: 4px;\n  overflow: hidden;\n  background-color: white;\n  box-sizing: unset;\n"], ["\n  height: 8px;\n  border: 0.5px solid rgba(24, 32, 38, 0.16);\n  border-radius: 4px;\n  overflow: hidden;\n  background-color: white;\n  box-sizing: unset;\n"])));
var Progress = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  transition: width 500ms ease-in;\n  height: 7px;\n  margin: 0.5px;\n  border: 1px solid white;\n  border-radius: 3.5px;\n  width: ", ";\n  background-color: #4de07e;\n"], ["\n  transition: width 500ms ease-in;\n  height: 7px;\n  margin: 0.5px;\n  border: 1px solid white;\n  border-radius: 3.5px;\n  width: ", ";\n  background-color: #4de07e;\n"])), function (_a) {
    var progress = _a.progress;
    return progress + "%";
});
var ProgressBar = function (_a) {
    var progress = _a.progress;
    return (React.createElement(TotalBar, null,
        React.createElement(Progress, { progress: progress })));
};
export { ProgressBar };
var templateObject_1, templateObject_2;
